import gql from "graphql-tag"
import fullPerksSaga from "./fragments/fullPerksSaga"
import {rawQuery as rawStockQuery} from "./StockQuery"

const rawQuery = gql`
  fragment PerksSaga on Query {
    perksSaga(uuid: $uuid) {
      ...fullPerksSaga
    }
  }
`

const query = gql`
  query PerksSaga($uuid: String) {
    ...PerksSaga
  }
  ${rawQuery}
  ${fullPerksSaga}
`

export const withStockQuery = gql`
  query PerksSaga($uuid: String, $dealId: ID) {
    ...PerksSaga
    ...PerksSagaStockCount
  }
  ${rawQuery}
  ${rawStockQuery}
  ${fullPerksSaga}
`

export const withStockQueryToString = withStockQuery.loc.source.body

export const toString = query.loc.source.body

export default query
